export class OptionRegion {
  label: string;
  value: string;
  isAvailable: boolean;

  constructor(data: any) {
    this.label = data.location || '';
    this.value = data.zone || '';
    this.isAvailable = !!data.is_available || false;
  }
}
